/* eslint-disable no-param-reassign */
const setScalabilityMode = async (publisher, scalabilityMode, codecsWhitelist = null) => {
  if (!scalabilityMode || !publisher) {
    return;
  }
  const [sender] = await publisher._getRoutedVideoSenders();
  if (!sender) {
    return;
  }
  const senderParameters = sender.getParameters();
  if (Array.isArray(codecsWhitelist)) {
    const allowedCodecs = codecsWhitelist.map(codec => codec.toLowerCase());
    const hasAnyAllowedCodec = senderParameters.codecs?.some(
      codec => allowedCodecs.includes(codec.mimeType.split('/')[1]?.toLowerCase())
    );
    if (!hasAnyAllowedCodec) {
      return;
    }
  }
  senderParameters.encodings.forEach((encoding) => {
    encoding.scalabilityMode = scalabilityMode; // eslint-disable-line no-param-reassign
  });
  try {
    await sender.setParameters(senderParameters);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(`Unable to set scalabilityMode. ${err.message}`);
  }
};

export default setScalabilityMode;
